import { render } from "./MaterialsManager.vue?vue&type=template&id=543d65fb&lang=pug"
import script from "./MaterialsManager.vue?vue&type=script&lang=ts"
export * from "./MaterialsManager.vue?vue&type=script&lang=ts"
script.render = render

export default script